export default __webpack_public_path__ + "static/media/no_img_product.75182855.png";